module.exports = __webpack_public_path__ + "img/lantern4.fb26d527.png";